function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("style", null, ".cls-2{fill:#d6242d;}"));

var _ref3 =
/*#__PURE__*/
React.createElement("title", null, "AWS-IAM_Role");

var _ref4 =
/*#__PURE__*/
React.createElement("g", {
  id: "Working"
}, React.createElement("path", {
  className: "cls-2",
  d: "M7.94,31.62c0-.28,0-.55,0-.83a19.8,19.8,0,0,1,39.55-1.35l-2,.13A17.8,17.8,0,0,0,9.92,30.79c0,.25,0,.5,0,.75Z"
}), React.createElement("path", {
  className: "cls-2",
  d: "M8.73,32.22c0-.34,0-1.11,0-1.31a16.49,16.49,0,0,1,6.55-13.07l.1-.07a18.34,18.34,0,0,1,9.3-2.51A17.61,17.61,0,0,1,41.73,27.69l-1.92.54a15.6,15.6,0,0,0-15.16-11,16.33,16.33,0,0,0-8.23,2.2A14.48,14.48,0,0,0,10.7,30.91c0,.2,0,.94,0,1.26Z"
}), React.createElement("path", {
  className: "cls-2",
  d: "M10.05,37.83l-.27-2a11.65,11.65,0,0,0,5-1.67c3.31-2.4,10.31-3.26,14.09-3a23.81,23.81,0,0,1,7.06,2.22A17.59,17.59,0,0,0,39,34.57,29,29,0,0,0,44,34.29l.17,0c.59-.06,1.17-.12,1.73-.16l.56,0V30.52l-.21,0-1.8.17-1.36.12-.15-2,1.34-.11,1.77-.17.46-.05a1.73,1.73,0,0,1,2,1.72v4.09A1.74,1.74,0,0,1,46.88,36h-.14l-.62.05-1.7.16-.18,0a28.57,28.57,0,0,1-5.54.27,16.54,16.54,0,0,1-3.58-1.29A22.25,22.25,0,0,0,28.7,33.2c-3.4-.26-9.89.51-12.76,2.6A13.61,13.61,0,0,1,10.05,37.83ZM46.74,34Z"
}), React.createElement("path", {
  className: "cls-2",
  d: "M37.37,30.78c-.57-.17-1.2-.41-1.93-.69a18.5,18.5,0,0,0-7.73-1.65c-4.86.29-7.22.57-9,1.08l-.56-1.92c2-.56,4.42-.86,9.45-1.15a20.24,20.24,0,0,1,8.56,1.77c.68.27,1.28.49,1.76.63Z"
}), React.createElement("path", {
  className: "cls-2",
  d: "M7.4,38c-2.14,0-4.25-.39-5.34-1.48A1.7,1.7,0,0,1,1.53,35c.24-1.27,1.87-2,4.14-3,1-.41,1.93-.84,2.79-1.31l1,1.75c-.94.52-2,1-2.95,1.4a18.94,18.94,0,0,0-2.82,1.4c.9.63,3.16,1,6.13.59l.27,2A20.68,20.68,0,0,1,7.4,38Z"
}), React.createElement("path", {
  className: "cls-2",
  d: "M42.35,32.56h-4a1.71,1.71,0,0,1-1.7-1.71V28.66a1.7,1.7,0,0,1,1.7-1.7h4a1.7,1.7,0,0,1,1.7,1.7v2.19A1.71,1.71,0,0,1,42.35,32.56Zm-3.7-2h3.4V29h-3.4Z"
}), React.createElement("path", {
  className: "cls-2",
  d: "M16.49,35.28a13,13,0,0,1-8.22-3L9.6,30.83a11,11,0,0,0,7,2.45Z"
}));

var SvgAwsIamRole = function SvgAwsIamRole(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    className: "svgCloudServices",
    viewBox: "0 0 50 50",
    ref: svgRef
  }, props), _ref2, title === undefined ? _ref3 : title ? React.createElement("title", null, title) : null, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgAwsIamRole, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/AWS-IAM_Role.b2d7a795.svg";
export { ForwardRef as ReactComponent };